// @flow
export const PAGE_READY = 'PAGE_READY';
export const PAGE_READINESS_RESET = 'PAGE_READINESS_RESET';
export const SET_NAVBAR_VISIBILITY = 'SET_NAVBAR_VISIBILITY';
export const SET_FOOTER_VISIBILITY = 'SET_FOOTER_VISIBILITY';
export const SET_CUREFY_DOMAIN = 'SET_CUREFY_DOMAIN';
